import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class AuthgaurdService implements CanActivate {

  constructor(public _baseService: BaseService) { }


  canActivate(): boolean {

    if (this._baseService.isTokenExist())
      return true;
      else {

        this._baseService.redirectTo('login');
        return false;
  
      }

  }


}
